module.exports = __webpack_public_path__ + "img/alan-smc.9f35307e.jpg";